import { Component, Prop, h } from '@stencil/core';

import { actions } from '../../../actions/actions.interactive-banner';
import { bannerSizeType, hasBoostAmount } from '../../../utils/utils.interactive-banner';
import { dealerBoostFormatted, formatOfferExpiration, formatPrice } from '../../../utils/utils.offer';

@Component({
  tag: 'banner-eligible',
  styleUrl: 'banner-eligible.css',
})
export class BannerEligible {
  @Prop() yearId: number;
  @Prop() make: string = '';
  @Prop() model: string = '';
  @Prop() trim: string = '';
  @Prop() offerId: string = '';
  @Prop() amount: number = 0;
  @Prop() status: string = '';
  @Prop() expirationDate: string = '';
  @Prop() offerCode: string = '';
  @Prop() markupAmounts: object = {};
  @Prop() totalOfferAmounts: object = {};
  @Prop() bannerEligibleSize: bannerSizeType = 'large';

  viewCertificate() {
    actions.viewOfferCertificate();
  }

  render() {
    const resetTextLink = 'Start a New Offer';
    const title = hasBoostAmount(this.markupAmounts) ? 'Your Kelley Blue Book Instant Cash Offer + Boost' : 'Your Kelley Blue Book Instant Cash Offer';
    const carName = `${this.yearId} ${this.make} ${this.model} ${this.trim}`;

    const bannerBlockClass = {
      'banner-eligible-block': true,
      'flex-col py-4': this.bannerEligibleSize !== 'large',
      'box-border h-130': this.bannerEligibleSize === 'large',
    };

    const containTitleClass = {
      'mb-2': this.bannerEligibleSize !== 'large',
      'mt-2': this.bannerEligibleSize === 'small' || this.bannerEligibleSize === 'xsmall',
      'text-center flex flex-col justify-center': this.bannerEligibleSize === 'large',
      'w-1/2': this.bannerEligibleSize === 'medium',
    };

    const containContentClass = {
      'flex flex-col items-center': this.bannerEligibleSize === 'small' || this.bannerEligibleSize === 'xsmall',
    };

    const lblPriceClass = {
      'banner-eligible-amount': true,
      'text-left': this.bannerEligibleSize === 'medium',
      'my-0.5': hasBoostAmount(this.markupAmounts) && this.bannerEligibleSize === 'large',
    };

    const bannerContainResetClass = {
      'flex items-end': this.bannerEligibleSize === 'medium',
    };

    const bannerResetClass = {
      'basis-13p flex flex-col': true,
      'items-center': this.bannerEligibleSize === 'small' || this.bannerEligibleSize === 'xsmall',
      'items-reverse': this.bannerEligibleSize !== 'small' && this.bannerEligibleSize !== 'xsmall',
    };

    const bannerKBBLogoWithLinkClass = {
      'basis-full': this.bannerEligibleSize !== 'large',
      'pt-0': true,
    };

    const bannerLogoClass = {
      'flex items-center': this.bannerEligibleSize === 'large',
      'flex flex-col items-center': this.bannerEligibleSize === 'small' || this.bannerEligibleSize === 'xsmall',
      absolute: this.bannerEligibleSize === 'medium',
    };

    const subContent = {
      'text-xs/4': true,
      'text-left': this.bannerEligibleSize === 'medium',
    };

    const logoAndContentClass = {
      'flex flex-row flex-row-reverse justify-between': this.bannerEligibleSize === 'medium',
      'flex flex-row justify-between': this.bannerEligibleSize === 'large',
    };

    const viewCertificateAndResetClass = {
      'flex flex-col-reverse justify-between': this.bannerEligibleSize === 'large',
      'flex flex-row justify-between': this.bannerEligibleSize === 'medium',
      'flex flex-col': this.bannerEligibleSize === 'small' || this.bannerEligibleSize === 'xsmall',
      'min-w-250 pb-3 pt-1.5': this.bannerEligibleSize === 'large',
    };

    const amountClass = {
      'text-xxs': true,
      block: this.bannerEligibleSize !== 'large',
      'mr-1.5': this.bannerEligibleSize === 'large',
    };

    const boostAmountClass = {
      'text-xxs': true,
      block: this.bannerEligibleSize !== 'large',
    };

    return (
      <div class={bannerBlockClass}>
        <div class={logoAndContentClass}>
          <div class={bannerLogoClass}>
            <banner-logo
              textLink={resetTextLink}
              hiddenOnMobile={false}
              txtLinkHiddenOnDesktop={true}
              showDesktop={this.bannerEligibleSize === 'large'}
              class={bannerKBBLogoWithLinkClass}
              hiddenReset={true}
              textResetSize="sm"
              logoWithMPTop={false}
            />
          </div>
        </div>
        <div class={containTitleClass}>
          <div class={containContentClass}>
            <span class={subContent}>{title}</span>
            <p class="mt-0 mb-0 font-semibold font-open-sans">{carName}</p>
            <h1 class={lblPriceClass}>{dealerBoostFormatted(this.totalOfferAmounts)}</h1>
            {hasBoostAmount(this.markupAmounts) && (
              <div>
                <span class={amountClass}>Kelley Blue Book® Instant Cash Offer: {formatPrice(this.amount)}</span>
                <span class={boostAmountClass}>
                  Boost Amount: {dealerBoostFormatted(this.markupAmounts)} <i>see certificate for details</i>
                </span>
              </div>
            )}
            <span class="text-xxs block font-bold">Offer good until: {formatOfferExpiration(this.expirationDate)}</span>
          </div>
        </div>
        <div class={viewCertificateAndResetClass}>
          <div>
            <ico-button
              label="View Offer Certificate"
              buttonSize={this.bannerEligibleSize === 'xsmall' ? 'xsmall' : 'xmedium'}
              buttonStyle="tertiary-secondary"
              whenClicked={() => {
                this.viewCertificate();
              }}
            />
          </div>
          <div class={bannerContainResetClass}>
            <banner-reset textLink={resetTextLink} showDesktop={this.bannerEligibleSize === 'large'} class={bannerResetClass} textResetSize="sm" />
          </div>
        </div>
      </div>
    );
  }
}
